import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output
} from "@angular/core";
import {TIntSortDirection} from "./type";
import {THorizontalAlign} from "../../types";

@Component({
  selector: 'int-table-sorting',
  template: `
    <div class="table-sorting-container">
      <int-sort-icon [order]="direction" class="icon" [class.show]="direction"></int-sort-icon>
      <ng-content></ng-content>
    </div>

  `,
  styles: [`
    :host {
      display: flex;
      align-items: center;
      position: relative;
      cursor: pointer;
    }
    .table-sorting-container {
      position: relative;
      display: flex;
      align-items: center;
    }
    .icon {
      opacity: 0;
      position: absolute;
      transform: translateX(-100%);
      transition: opacity, transform 0.3s ease;
    }
    :host:hover .icon {
      opacity: 1!important;
    }
    .show.icon {
      opacity: 1!important;
    }
    :host[data-table-sorting-vertical-align="start"] {
      justify-content: flex-start;
    }
    :host[data-table-sorting-vertical-align="end"] {
      justify-content: flex-end;
    }
    :host[data-table-sorting-vertical-align="center"] {
      justify-content: center;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntTableSortingComponent {

  @Input() direction: TIntSortDirection | null = null;
  @Input() fieldName: string | null = null;
  @Input() horizontalAlign: THorizontalAlign = 'start';
  @Output() onSort = new EventEmitter<[string, TIntSortDirection | null]>();

  @HostListener('click')
  onSortHandler() {
    const direction: TIntSortDirection =
      this.direction === null
        ? 'ASC'
        : this.direction === 'ASC'
          ? 'DESC'
          : null;
    if(this.fieldName) {
      this.onSort.emit([this.fieldName, direction]);
    }
  }
  @HostBinding('attr.data-table-sorting-vertical-align') get _va() {
    return this.horizontalAlign;
  }
}
